import type { FC } from 'react'

const Spinner: FC<{
  className?: string
}> = ({ className }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={['spinner', className].join(' ')}
  >
    <g>
      <circle cx="4" cy="24" r="4" fill="#3F3F46" />
      <circle cx="44" cy="24" r="4" fill="#3F3F46" />
      <circle cx="24" cy="4" r="4" fill="#3F3F46" />
      <circle cx="24" cy="44" r="4" fill="#3F3F46" />
      <circle cx="38.1421" cy="9.85784" r="4" fill="#FBBF24" />
      <circle cx="9.85791" cy="38.1421" r="4" fill="#3F3F46" />
      <circle cx="38.142" cy="38.1421" r="4" fill="#3F3F46" />
      <circle cx="9.85779" cy="9.85785" r="4" fill="#3F3F46" />
    </g>
  </svg>
)

export default Spinner
